// 法人情報詳細フッターボタン
import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  handleBack: () => void;
  handleEditHistory: () => void;
  handleCorporateDelete: () => void;
  handleConfirm: () => void;
  disabledCorporateDeleteBtn: () => boolean;
  disabledConfirmBtn: () => boolean;
}

const CorporateInfoDetailFooterButtons: React.FC<Props> = ({
  handleBack,
  handleEditHistory,
  handleCorporateDelete,
  handleConfirm,
  disabledCorporateDeleteBtn,
  disabledConfirmBtn,
}) => {
  return (
    <div className="footer_btn_wrapper mb-3">
      <div className="d-flex justify-content-between mb-3">
        <Button className="btn-text-color btn-mini" variant="outline-success" onClick={handleBack}>
          戻る
        </Button>
        <Button
          className="btn-danger btn-mini"
          onClick={handleCorporateDelete}
          disabled={disabledCorporateDeleteBtn()}
        >
          法人情報を削除
        </Button>
        <Button
          className="btn-success btn-mini"
          onClick={handleConfirm}
          disabled={disabledConfirmBtn()}
        >
          確認
        </Button>
      </div>
      <Button
        className="btn-text-color btn-mini"
        variant="outline-success"
        onClick={handleEditHistory}
      >
        編集履歴
      </Button>
    </div>
  );
};

export default memo(CorporateInfoDetailFooterButtons);
